const business = {
  state: {
    businessList: {}
  },
  mutations: {
    SET_BUSINESS_LIST: (state, data) => {
      state.businessList = data;
    },
    CLEAR_BUSINESS_LIST: state => {
      state.businessList = {};
    }
  },
  actions: {
    setBusinessList({ commit }, data) {
      commit("SET_BUSINESS_LIST", data);
    },
    clearBusinessList({ commit }) {
      commit("CLEAR_BUSINESS_LIST");
    }
  }
};
//询价审批的参数

export default business;
